import type { LiveCueSheetV1 } from '@/types/player/perform-control-v1.types';

export type AgentDeckRowLike = {
  itemId?: string;
  presentationKind?: string;
  fileType?: string;
  isAgentBacked?: boolean;
};

function isAgentDeckFileType(fileType?: string): boolean {
  return fileType === 'presentation' || fileType === 'pptx' || fileType === 'ppt';
}

export function isAgentDeckRow(row: AgentDeckRowLike | undefined): boolean {
  if (!row) {
    return false;
  }
  return row.presentationKind === 'agent' || row.isAgentBacked === true || isAgentDeckFileType(row.fileType);
}

/**
 * Live Control must not rely on the simulation cue store (it is not updated while on air).
 * Prefer the live cue sheet, then any mapped/simulation rows, then an optional media fallback.
 */
export function isAgentDeckItemId(
  itemId: string | undefined,
  sources: {
    cueSheet?: LiveCueSheetV1 | null;
    rows?: AgentDeckRowLike[];
    isPresentationFile?: (itemId: string) => boolean;
  } = {},
): boolean {
  if (!itemId) {
    return false;
  }
  const sheetItems = sources.cueSheet?.items;
  if (Array.isArray(sheetItems) && sheetItems.some((row) => row.itemId === itemId && isAgentDeckRow(row))) {
    return true;
  }
  if (sources.rows?.some((row) => row.itemId === itemId && isAgentDeckRow(row))) {
    return true;
  }
  return sources.isPresentationFile?.(itemId) === true;
}
